<template>
  <a
    :href="url ?? 'javascript:;'"
    :class="{ 'cursor-default': !url }"
    class="bg-bubblegum-50 py-4 pl-4 pr-7 rounded-lg flex items-center group justify-between border border-bubblegum-200"
  >
    <span class="flex items-center space-x-4 w-full">
      <!-- eslint-disable-next-line vue/no-undef-components -->
      <lottie-player
        autoplay
        loop
        mode="normal"
        :src="lottieUrl"
        class="w-full max-w-14 h-14"
      />
      <span class="!text-lg leading-tight w-full">
        {{ title }} <span class="font-bold">{{ description }}</span>?
      </span>
      <fa :icon="['fal', 'chevron-right']" />
    </span>
  </a>
</template>

<script>
import { getAssetUrl } from '@/helpers/url';

export default {
  name: 'VetsterShoutout',

  props: {
    description: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      default: null,
    },
  },

  computed: {
    lottieUrl() {
      return getAssetUrl('lottie/hand-holding-heart.json');
    },
  },
};
</script>
